import { createSlice } from '@reduxjs/toolkit';

export const testExecutionsSlice = createSlice({
  name: 'testExecutions',
  initialState: {},
  reducers: {},
});

export default testExecutionsSlice.reducer;
